import { select, call, put } from 'redux-saga/effects';
import { getFlatNavigationRoute } from '@core/js/utils/apiRoutes';
import { makeRequest } from '@core/js/sagas/makeRequest';
import { navigationLoaded } from '@core/js/actions/initialActions';

export function getNavItemSlugAtLevel(flatNav, startingSlug, desiredLevel) {
    if (_.isObject(flatNav) &&
        _.isInteger(desiredLevel) &&
        desiredLevel >= 0 &&
        startingSlug) {
        const currentSlug = startingSlug;
        let navItem = flatNav[currentSlug];

        while (navItem) {
            if (navItem.nestLevel < desiredLevel) {
                break;
            }

            if (navItem.nestLevel === desiredLevel) {
                return navItem.slug;
            }

            navItem = flatNav[navItem.parentSlug];
        }
    }

    return null;
}

export function flatNavSelector(state) {
    return _.get(state, 'core.flatNavigation');
}

export function* getFlatNavigationSaga() {
    const state = yield select();
    let flatNav = flatNavSelector(state);

    if (flatNav) {
        return flatNav;
    }

    flatNav = yield call(makeRequest, getFlatNavigationRoute(state));
    yield put(navigationLoaded(flatNav));

    return flatNav;
}

export function getFlatNavigationSync(store) {
    const state = store.getState();
    let flatNav = flatNavSelector(state);

    if (flatNav) {
        return flatNav;
    }

    const route = getFlatNavigationRoute(state);
    $.ajax(route.path, {
        async: false,
        success: (data, status, xhr) => {
            flatNav = data;
            store.dispatch(navigationLoaded(flatNav));
        },
        error: (xhr, status, err) => {
            throw err;
        }
    });

    return flatNav;
}
